import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Pivot, PivotItem } from '@fluentui/react';
import ProtocolsListComponent from '../../components/Protocols/ProtocolsList/ProtocolsList.Component';
import ProtocolsPortfolioStatisticsComponent from '../../components/Protocols/ProtocolsPortfolioStatistics/ProtocolsPortfolioStatistics.Component';
import { PageHeader } from '../../commons/component/PageHeader/PageHeader';

////i18Next
import { useTranslation } from 'react-i18next';

const TABS = ['list', 'statistics'] as const;
type TabKey = typeof TABS[number];

const normalizeTab = (value: string | null): TabKey =>
  value && (TABS as readonly string[]).includes(value) ? (value as TabKey) : 'list';

export const ProtocolsAgreementsPage = () => {
  //useTranslation()
  const [t] = useTranslation();
  const location = useLocation();

  /* La solapa elegida vive en la URL (?tab=statistics), igual que en el detalle del
     contrato: así se puede compartir el enlace y volver atrás sin perderla. */
  const [selectedTab, setSelectedTab] = useState<TabKey>(() =>
    normalizeTab(new URLSearchParams(location.search).get('tab'))
  );

  useEffect(() => {
    setSelectedTab(normalizeTab(new URLSearchParams(location.search).get('tab')));
  }, [location.search]);

  const handleTabChange = (item?: PivotItem) => {
    const next = normalizeTab((item?.props?.itemKey as string | undefined) ?? null);
    setSelectedTab(next);

    const params = new URLSearchParams(location.search);
    params.set('tab', next);
    window.history.replaceState(window.history.state, '', `${window.location.pathname}?${params.toString()}`);
  };

  return (
    <>
      <PageHeader title={t('protocolsAgreementsPage.protocolsAgreementsTitle')} />
      <div className="Section Tabed">
        <Pivot selectedKey={selectedTab} onLinkClick={handleTabChange}>
          <PivotItem itemKey="list" headerText={t('protocolsAgreementsPage.tabs.list', 'Protocolos')}>
            <ProtocolsListComponent />
          </PivotItem>
          <PivotItem itemKey="statistics" headerText={t('protocolsAgreementsPage.tabs.statistics', 'Estadísticas')}>
            {/* Se monta sólo al elegirla: Pivot no renderiza las solapas ocultas, así
                que las estadísticas de toda la cartera no se piden si nadie las mira. */}
            {selectedTab === 'statistics' && <ProtocolsPortfolioStatisticsComponent />}
          </PivotItem>
        </Pivot>
      </div>
    </>
  );
};
